import { AxArtwork } from "@dynata/axiom3";
import errorImage from "@dynata/axiom3-images/png/general_error.png";

export function DashboardError() {
  return (
    <AxArtwork
      title="There was an error getting the dashboard"
      image={errorImage}
      description="Error details"
    />
  );
}
